import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import InfoSections from "./components/InfoSections";
import CategorySection from "./components/CategorySection";
import QcGuides from "./components/QcGuides";
import Faq from "./components/Faq";
import { MAIN_SITE_URL } from "@/constants";

export default function Home() {
  const { t } = useTranslation();

  const faqItems = Array.from({ length: 9 }, (_, i) => ({
    q: t(`faq.items.q${i + 1}.q`),
    a: t(`faq.items.q${i + 1}.a`),
  }));

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <InfoSections />
        <CategorySection />
        <QcGuides />

        <section id="faq" className="bg-background-100">
          <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
            <h2 className="text-center text-2xl font-bold text-foreground-950 md:text-3xl">
              {t("faq.title")}
            </h2>
            <div className="mt-8">
              <Faq items={faqItems} />
            </div>
          </div>
        </section>

        <section className="bg-primary-500">
          <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
            <div className="mx-auto max-w-2xl text-center">
              <h2 className="text-2xl font-bold text-white md:text-3xl">
                {t("finalCta.title")}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-white/90 md:text-base">
                {t("finalCta.body")}
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
                >
                  {t("finalCta.button")}
                  <i className="ri-arrow-right-up-line"></i>
                </a>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
                >
                  {t("finalCta.secondary")}
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}